import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const logos = [
  'assets/logos/1.png',
  'assets/logos/2.png',
  'assets/logos/3.png',
  'assets/logos/4.png',
  'assets/logos/5.png',
];

const LogoCarousel = () => {
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    dots: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="bg-white py-4 border-b border-[#8080801c] ">
      <div className="mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center">
          <div className="md:w-1/4 w-full text-center md:text-left mb-4 md:mb-0">
            <h4 className="text-2xl font-semibold">
              Accreditations and Rankings
            </h4>
          </div>
          <div className="md:w-3/4 w-full">
            <Slider {...settings}>
              {logos.map((src, index) => (
                <div key={index} className="px-4">
                  <img
                    src={src}
                    alt={`logo-${index + 1}`}
                    className="mx-auto max-h-24 object-contain"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoCarousel;
